import { datConditons } from './constants/dat-condition.constant'

function convertHoursToHM(decimalHours, ceil = false) {
  const hours = Math.floor(decimalHours);
  let minutes = Math.floor((decimalHours - hours) * 60);

  if(ceil) {
    minutes = Math.ceil((decimalHours - hours) * 60);
  }
  return `${hours}h${minutes}p`;
}


function checkDATConditions(license, totalTG, totalQD, TG_dung_hang, TG_ban_dem_dung_hang, TG_tu_dong) {  
    const found = datConditons.find(entry => entry.license === license);
    if (!found) {
      return { valid: false, message: `Không tìm thấy hạng bằng lái: ${license}` };
    }
  
    const fields = { totalTG, totalQD, TG_dung_hang, TG_ban_dem_dung_hang, TG_tu_dong };
    const results = {};
    let allValid = true;
  
    for (const [field, value] of Object.entries(fields)) {
      const requiredValue = found[field];
      if (value >= requiredValue) {
        results[field] = "Đã đủ";
      } else {
        if (field === "totalQD") {
          results[field] = `Thiếu ${Math.ceil((requiredValue - value) * 100) / 100} km`;
        } else {
          results[field] = `Thiếu ${convertHoursToHM(requiredValue - value, true)}`;
        }
        allValid = false;
      }
    }
  
    return { valid: allValid, details: results };
  }

  export { convertHoursToHM, checkDATConditions };
  